// auto-generated by Typewriter template _enums.tst from PortCall.Models\CoordinationCards\CoordinationEditingPolicy.cs
export enum CoordinationEditingPolicy { 
    AllowAgentStatusEdits = 1,
    None = 0
}

export const CoordinationEditingPolicyDisplayName : { [val : number] : string } = { 
    1: 'AllowAgentStatusEdits',
    0: 'None'
}

export const CoordinationEditingPolicys : { Id : CoordinationEditingPolicy, Name : string }[] = [ 
    { Id: CoordinationEditingPolicy.AllowAgentStatusEdits, Name: 'AllowAgentStatusEdits' },
    { Id: CoordinationEditingPolicy.None, Name: 'None' }
]



// WEBPACK FOOTER //
// ./server/enums/CoordinationEditingPolicy.ts